import StyleValue from './StyleValue';
import FormatValue from './FormatValue';

export class Markdown {
  /**
   * @param {string} type
   * @param {FormatValue} [format]
   * @param {StyleValue} [style]
   * @param {sting} [fusion]
   */
  constructor(type, format, style, fusion) {
    this.type = type;
    this.format = format;
    this.style = style;
    this.fusion = fusion;
  }

  /**
   * Сдвинуть стили
   * @param {number} dx - целое число, смещение по горизонтали
   * @param {number} dy - целое число, смещение по вертикали
   * @return {ExcelStyleItem}
   */
  shift(dx, dy) {
    throw new Error('not implemented');
  }

  static fromJSON(obj) {
    if (typeof obj !== 'object' || !obj) throw new Error('not an object');
    switch (obj.type) {
      case "cell":
        if (!Array.isArray(obj.coord)) throw new Error(`coord is not an array in ${JSON.stringify(obj)}`);
        const [x, y] = obj.coord;
        if (typeof x !== "number") throw new Error(`coord[0] is not a number in ${JSON.stringify(obj)}`);
        if (typeof y !== "number") throw new Error(`coord[1] is not a number in ${JSON.stringify(obj)}`);
        return new CellMarkdown([x, y], FormatValue.fromJSON(obj.format), StyleValue.fromJSON(obj.style), obj.fusion);
      case "row":
        if (typeof obj.coord !== "number") throw new Error(`coord is not a number in ${JSON.stringify(obj)}`);
        return new RowMarkdown(obj.coord, FormatValue.fromJSON(obj.format), StyleValue.fromJSON(obj.style), obj.fusion);
      case "column":
        if (typeof obj.coord !== "number") throw new Error(`coord is not a number in ${JSON.stringify(obj)}`);
        return new ColumnMarkdown(obj.coord, FormatValue.fromJSON(obj.format), StyleValue.fromJSON(obj.style), obj.fusion);
      case "row_range":
      case "column_range":
        throw new Error('I am too lazy to implement it');
      default:
        throw new Error(`Unknown type ${obj.type} in ${JSON.stringify(obj)}`);
    }
  }
}

export class CellMarkdown extends Markdown {
  constructor([x, y], format, style, fusion) {
    super("cell", format, style, fusion);
    this.coord = [x, y]; // x - столбец, y - строка
  }

  shift(dx, dy) {
    const [x, y] = this.coord;
    return new CellMarkdown([x + dx, y + dy], this.format, this.style, this.fusion);
  }
}

export class RowMarkdown extends Markdown {
  constructor(y, format, style, fusion) {
    super("row", format, style, fusion);
    this.coord = y;
  }

  shift(dx, dy) {
    return new RowMarkdown(this.coord + dy, this.format, this.style, this.fusion);
  }
}

export class ColumnMarkdown extends Markdown {
  constructor(x, format, style, fusion) {
    super("column", format, style, fusion);
    this.coord = x;
  }

  shift(dx, dy) {
    return new ColumnMarkdown(this.coord + dx, this.format, this.style, this.fusion);
  }
}

export class RowRangeMarkdown extends Markdown {
  constructor(y, [m, n], format, style, fusion) {
    super("row_range", format, style, fusion);
    this.coord = y;
    this.range = [m, n];
  }

  shift(dx, dy) {
    const [m, n] = this.range;
    return new RowRangeMarkdown(this.coord + dy, [m + dx, n], this.format, this.style, this.fusion);
  }
}

export class ColumnRangeMarkdown extends Markdown {
  constructor(x, [m, n], format, style, fusion) {
    super("column_range", format, style, fusion);
    this.coord = x;
    this.range = [m, n];
  }

  shift(dx, dy) {
    const [m, n] = this.range;
    return new ColumnRangeMarkdown(this.coord + dx, [m + dy, n], this.format, this.style, this.fusion);
  }
}

export default Markdown;
